import DevicePreview from './DevicePreview';

export default DevicePreview;
